export const GAME_CONFIG = {
  roundBalls: 10,
  specialCupScore: 250,
  rows: 10,
  columns: 10,
  cupSpacing: 0.9,
  cupTopRadius: 0.4,
  cupInnerRadius: 0.34,
  cupBottomRadius: 0.26,
  cupHeight: 0.3,
  cupWallThickness: 0.028,
  cupSegments: 12,
  ballRadius: 0.165,
  entryLead: 0,
  boardCenter: { x: 0, y: 2.56, z: -3.3 },
  boardSize: { x: 9.55, y: 0.28, z: 9.55 },
  releasePosition: { x: 0, y: 4.35, z: 8.75 },
  cameraPosition: { x: 0, y: 7.35, z: 13.4 },
  cameraTarget: { x: 0, y: 2.9, z: -3.45 },
  minFlightTime: 1,
  maxFlightTime: 1.9,
  chargeDuration: 1.35,
  settleSpeed: 0.38,
  settleAngularSpeed: 1.15,
  settleDuration: 0.72,
  missTimeout: 7.5,
  resultHoldDuration: 1.15,
  specialCupIndices: [12, 28, 44, 57, 73, 89, 95] as readonly number[],
} as const;

export const CUP_COUNT = GAME_CONFIG.rows * GAME_CONFIG.columns;
export const BOARD_TOP_Y = GAME_CONFIG.boardCenter.y + GAME_CONFIG.boardSize.y / 2;
export const CUP_RIM_Y = BOARD_TOP_Y + GAME_CONFIG.cupHeight;
